// DateConditionMode lives in it's own file to keep workbook- and non-workbook-dependencies apart.

/**
 * @enum {string}
 * @readonly
 */
export const DateConditionMode = {
  CALENDAR: 'Calendar',
  SLIDER: 'Slider'
};
